import { action, makeObservable, observable } from 'mobx';
import { RevenueDonutDataItem } from 'src/integration/data/RevenueDonutData';

class RevenueByMarketStore {
  @observable revenueByMarketData: RevenueDonutDataItem[] = [];

  constructor() {
    makeObservable(this);
  }

  @action setRevenueByMarketData = (data: RevenueDonutDataItem[]) => {
    this.revenueByMarketData = data;
  };
}

export default RevenueByMarketStore;
